$(document).ready(function () {
    $('.panel-title').on('click', function (e) {
        if ($(this).parent().parent().attr('data-toggle')) {
            return;
        }

        $(this).closest('.panel').find('.panel-body, .panel-footer').toggleClass('hidden');
    });
});
